// Script for model page

import * as facets from './includes/facets';
facets.checkFacet();
facets.closeFacet();
// facets.filterModels(); // pas d'import, est appelée par les autres fonctions
facets.dropdown();

import * as versus from './includes/versus';
versus.addVersus();
versus.clickRemoveVersus();
versus.removeVersus();
versus.clearVersus();
versus.getThumbnail();

import * as carousel from './includes/carousel';
carousel.sync();
carousel.heightNormalization();


import * as similar from './includes/similar';
similar.defaultChecked();
similar.checkFacet();
// similar.filterModels();
